// ** React Imports
import { useEffect, useRef, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
    LeadCompanyStore,
    CompanyDialogStore,
    LeadSprintStore,
    SprintDialogStore,
    LeadActivityHistoryStore,
    ActivityHistoryDialogStore,
    LeadActivityCadenceStore,
    CadenceListDialogStore,
    LeadActivityOutcomeStore,
    ActivityOutcomes,
} from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import DoActivityOutcomes from './DoActivityOutcomes';
import StandardSkeleton from '../../common/StandardSkeleton';
import HtmlTextAreaView from '../../common2/Templating/HtmlTextAreaView';
import ContentEditor from '../../../v2/components/ContentEditor/ContentEditor';
import { TokenType } from '../../../v2/components/ContentEditor/types/content-editor-types';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityInboundSocialMedia = () => {
    const outcomesRecord = LeadActivityOutcomeStore.useState((s) => s.record);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchOutcomes = async () => {
            setHasLoaded(false);
            const response = await client.get(
                leadEndpoints.getactivityoutcomes.replace('{leadid}', '' + selectedLead?.id.toString()),
            );
            LeadActivityOutcomeStore.update((s) => {
                s.record = response.data;
            });
            setHasLoaded(true);
        };
        if (selectedLead != null) fetchOutcomes();
    }, []);

    const handleBodyTextChange = (value: string) => {
        LeadActivityOutcomeStore.update((s) => {
            s.record.socialMediaBody = value;
        });
    };

    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box>
                                    <Grid container alignContent="left" spacing={2}>
                                        <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                Incoming Social Media
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            alignContent="left"
                                            justifyContent={'left'}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <FormControl fullWidth>
                                                <ContentEditor
                                                    sx={{ height: 150 }}
                                                    html={outcomesRecord.socialMediaBody}
                                                    onChange={handleBodyTextChange}
                                                    error={false}
                                                    disabled={false}
                                                    showToolbar={false}
                                                    tokenType={TokenType.None}
                                                />
                                            </FormControl>
                                        </Grid>
                                        {/*<Grid item xs={12} md={2} alignItems="flex-start" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>*/}
                                        {/*    <Tooltip title="Send Message" >*/}
                                        {/*        <Button size='small' variant="outlined" color="info" startIcon={<SendIcon />} sx={{ mr: 3 }} onClick={sendSocialMedia}>*/}
                                        {/*            Send*/}
                                        {/*        </Button>*/}
                                        {/*    </Tooltip>*/}
                                        {/*</Grid>*/}
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            alignContent="left"
                                            justifyContent={'left'}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <DoActivityOutcomes />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export { DoActivityInboundSocialMedia };

export default DoActivityInboundSocialMedia;
